enum Mutation {
  SET_PAYLOAD = 'setPayload',
  SET_HOVERED_PAYLOAD = 'setHoveredPayload',
}

export default Mutation;
